import script from "./IndexPc.vue?vue&type=script&setup=true&lang=ts"
export * from "./IndexPc.vue?vue&type=script&setup=true&lang=ts"

import "../../style/IndexPc.css?vue&type=style&index=0&id=593c2f17&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-593c2f17"]])

export default __exports__